import {Component, OnInit} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {Collection} from '../../../Models/Collection';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormGroup} from '@angular/forms';
import {Property} from '../../../Models/Property';
import {PropertyService} from '../../../Services/property.service';

@Component({
  selector: 'app-manage-property',
  templateUrl: './manage-property.component.html',
  styleUrls: ['./manage-property.component.scss']
})
export class ManagePropertyComponent implements OnInit {
  public classicBox;
  public lastValue = {property: new Property()};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public isEdit = false;
  public propertyId: number;
  options: FormlyFormOptions = {};
  // weird! formly accept boolean as string!
  public hasPolicyToDisableProperty = 'false';

  constructor(
    public helper: Helper,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private propertyService: PropertyService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      new Promise((resolve, reject) => {
        if (Helper.isDefined(params['id'])) {
          this.propertyId = params['id'];
          this.isEdit = true;
          this.propertyService.getPropertyItem(this.propertyId).subscribe(resp => {
            this.CheckIfPropertyHasPolicyUpdateRule(resp);
            resolve(resp);
          });
        } else {
          resolve(new Property());
        }
      }).then(property => {
        this.lastValue = {property: (<Property>property)};
      }).then(() => {
        this.classicBox = <FormlyFieldConfig>[
          {
            className: 'section-label',
            template: '<div><strong>' + (this.isEdit) ? this.lastValue.property.name : this.translate.instant('admin.property.show.add.property') + '</strong></div>',
          },
        ];
        this.classicBox = <FormlyFieldConfig>[
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.property.show.property_name') + '</strong></div><hr />',
          },
          {
            fieldGroupClassName: 'row',
            key: 'property',
            fieldGroup: [
              {
                className: 'col-3 ',
                type: 'input',
                key: 'name',
                templateOptions: {
                  label: this.translate.instant('doctrine.property.name'),
                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    pattern: this.translate.instant('errors.invalid'),
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                      {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                className: 'col-3 ',
                type: 'input',
                key: 'description',
                templateOptions: {
                  label: this.translate.instant('doctrine.property.description'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    pattern: this.translate.instant('errors.invalid'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                      {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                className: 'col-3 ',
                type: 'input',
                key: 'code',
                templateOptions: {
                  label: this.translate.instant('doctrine.property.code'),
                  required: true,
                  maxLength: environment.maxStringLength,
                },
                expressionProperties: {
                  'templateOptions.disabled': `${this.hasPolicyToDisableProperty}`
                },
                validation: {
                  messages: {
                    pattern: this.translate.instant('errors.invalid'),
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                      {limit: field.templateOptions.maxLength})
                  },
                },
              },
            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.property.show.type_name') + '</strong></div><hr />',
          },
          {
            fieldGroupClassName: 'row',
            key: 'property',
            fieldGroup: [
              {
                key: 'status',
                type: 'ng-select',
                className: 'col-3 ',
                defaultValue: true,
                templateOptions: {
                  label: this.translate.instant('doctrine.property.status'),
                  required: true,
                  options: [
                    {label: this.translate.instant(Property.PROPERTY_AMOUNT), value: true},
                    {label: this.translate.instant(Property.PROPERTY_METERS), value: false}
                  ],
                },
              },
            ],
          }
        ];
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }


  submitItem(next: boolean) {
    if (next) {
      const property = JSON.parse(JSON.stringify(this.lastValue));

      delete  property.property.id;
      this.propertyService.manageProperty(property, this.isEdit, this.propertyId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/property/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/property/overview');
    }
  }

  private CheckIfPropertyHasPolicyUpdateRule(property: Property) {
    const codes = Property.getUnchangeableCodeProperties();

    for (const code of codes) {
      if (property.code === code) {
        this.hasPolicyToDisableProperty = 'true';
        break;
      }
    }
  }

}
